import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import { Table } from "reactstrap";

import { lang } from "../../../middleware/lang";
import { formatNumber } from "../../../middleware/common-functions";
import {
  GET_CONNECT_TRANSACTIONS,
  GetConnectTransactionsResponse,
} from "./queries";

const typeLabels: Record<string, string> = {
  charge: "Cargo",
  payment: "Pago",
  transfer: "Transferencia",
  payout: "Deposito",
  adjustment: "Ajuste",
  refund: "Reembolso",
  application_fee: "Comision",
};

const Transactions: React.FC = () => {
  const [cursor, setCursor] = useState<string | undefined>();
  const [allData, setAllData] = useState<any[]>([]);

  const { data, loading } = useQuery<GetConnectTransactionsResponse>(
    GET_CONNECT_TRANSACTIONS,
    {
      variables: { limit: 20, starting_after: cursor },
      fetchPolicy: "cache-and-network",
      onCompleted: (result) => {
        if (cursor && result?.getConnectTransactions.data) {
          setAllData((prev) => [...prev, ...result.getConnectTransactions.data]);
        }
      },
    }
  );

  const transactions = cursor
    ? allData
    : data?.getConnectTransactions.data || [];
  const hasMore = data?.getConnectTransactions.has_more || false;

  const loadMore = () => {
    const last = (data?.getConnectTransactions.data || []).slice(-1)[0];
    if (last) {
      setAllData(transactions);
      setCursor(last.id);
    }
  };

  if (!loading && transactions.length === 0) {
    return (
      <div className="text-center py-5">
        <i className="fas fa-exchange-alt fa-2x text-muted mb-3 d-block" />
        <p className="text-muted">
          {lang("No hay transacciones aun", "No transactions yet")}
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ebebeb",
        borderRadius: 12,
        overflow: "hidden",
      }}
    >
      <Table responsive hover className="mb-0">
        <thead>
          <tr style={{ background: "#f8f9fa" }}>
            <th>{lang("Fecha", "Date")}</th>
            <th>{lang("Tipo", "Type")}</th>
            <th>{lang("Descripcion", "Description")}</th>
            <th className="text-right">{lang("Monto", "Amount")}</th>
            <th className="text-right">{lang("Comision", "Fee")}</th>
            <th className="text-right">{lang("Neto", "Net")}</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((t) => (
            <tr key={t.id}>
              <td style={{ whiteSpace: "nowrap", fontSize: 13 }}>
                {new Date(t.created).toLocaleDateString("es-MX", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </td>
              <td>
                <span
                  style={{
                    fontSize: 12,
                    padding: "2px 8px",
                    borderRadius: 4,
                    background: "#f0f0f0",
                  }}
                >
                  {typeLabels[t.type] || t.type}
                </span>
              </td>
              <td style={{ fontSize: 13, color: "#666" }}>
                {t.description || "-"}
              </td>
              <td className="text-right" style={{ fontWeight: 600 }}>
                ${formatNumber(t.amount)}
              </td>
              <td
                className="text-right"
                style={{ color: t.fee > 0 ? "#FF6028" : "#666", fontSize: 13 }}
              >
                {t.fee > 0 ? `-$${formatNumber(t.fee)}` : "$0"}
              </td>
              <td
                className="text-right"
                style={{ fontWeight: 600, color: t.net >= 0 ? "#48BB78" : "#FF6028" }}
              >
                ${formatNumber(t.net)}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {loading && (
        <div className="text-center py-3">
          <span className="spinner-border spinner-border-sm" />
        </div>
      )}

      {hasMore && !loading && (
        <div className="text-center py-3">
          <button
            className="btn btn-sm"
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: 6,
              fontWeight: 600,
            }}
            onClick={loadMore}
          >
            {lang("Cargar mas", "Load more")}
          </button>
        </div>
      )}
    </div>
  );
};

export default Transactions;
